(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var section = document.querySelector('.hero-ss');
    if (!section) return;
    var slides = Array.prototype.slice.call(section.querySelectorAll('.hero-ss__slide'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.hero-ss__dot'));
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function start() { timer = setInterval(function () { go(i + 1); }, 5500); }
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { go(n); clearInterval(timer); start(); });
    });
    start();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ホームのオーバーレイ・ヘッダー: ヒーローを越えたら不透明(.is-scrolled)に切替
(function () {
  function initHeader() {
    if (!document.body.classList.contains('template-index')) return;
    var sh = document.querySelector('.section-header');
    var hero = document.querySelector('.hero-ss');
    if (!sh) return;
    function setHeaderH() { document.documentElement.style.setProperty('--header-h', Math.round(sh.getBoundingClientRect().height) + 'px'); }
    function threshold() { return hero ? Math.max(hero.offsetHeight - 90, 80) : 80; }
    function onScroll() { sh.classList.toggle('is-scrolled', window.scrollY > threshold()); }
    setHeaderH();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { setHeaderH(); onScroll(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var sec = document.getElementById('news-archive');
    if (!sec) return;
    var modal = sec.querySelector('#naModal');
    var store = sec.querySelector('.news-modal-store');
    if (!modal || !store) return;
    var dateEl = modal.querySelector('#naModalDate');
    var titleEl = modal.querySelector('#naModalTitle');
    var bodyEl = modal.querySelector('#naModalBody');
    function openModal(idx) {
      var art = store.querySelector('article[data-news-index="' + idx + '"]');
      if (!art) return;
      dateEl.textContent = art.getAttribute('data-news-date') || '';
      titleEl.textContent = art.getAttribute('data-news-title') || '';
      bodyEl.innerHTML = art.innerHTML;
      modal.hidden = false;
      document.body.classList.add('news-modal-open');
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('news-modal-open');
    }
    sec.querySelectorAll('.news-list-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(btn.getAttribute('data-news-index')); });
    });
    modal.querySelectorAll('[data-news-close]').forEach(function (c) {
      c.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var sec = document.getElementById('top-news-list');
    if (!sec) return;
    var modal = sec.querySelector('#newsModal');
    var store = sec.querySelector('.news-modal-store');
    if (!modal || !store) return;
    var dateEl = modal.querySelector('#newsModalDate');
    var titleEl = modal.querySelector('#newsModalTitle');
    var bodyEl = modal.querySelector('#newsModalBody');
    function openModal(idx) {
      var art = store.querySelector('article[data-news-index="' + idx + '"]');
      if (!art) return;
      dateEl.textContent = art.getAttribute('data-news-date') || '';
      titleEl.textContent = art.getAttribute('data-news-title') || '';
      bodyEl.innerHTML = art.innerHTML;
      modal.hidden = false;
      document.body.classList.add('news-modal-open');
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('news-modal-open');
    }
    sec.querySelectorAll('.news-list-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(btn.getAttribute('data-news-index')); });
    });
    modal.querySelectorAll('[data-news-close]').forEach(function (c) {
      c.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seisanchi"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var sec = document.querySelector('.seisanchi');
    if (!sec) return;
    var btns = Array.prototype.slice.call(sec.querySelectorAll('.pa-filter__btn'));
    var cards = Array.prototype.slice.call(sec.querySelectorAll('.pa-card'));
    var empty = sec.querySelector('#paEmpty');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var region = btn.getAttribute('data-region');
        var shown = 0;
        cards.forEach(function (c) {
          var match = region === 'all' || c.getAttribute('data-region') === region;
          c.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
